var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('sg-alert',{attrs:{"title":_vm.$t('Track shipping')},on:{"ok":function($event){return _vm.$emit('ok')}}},[_c('div',[_vm._v("\n    "+_vm._s(_vm.info)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }